function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import pathOr from 'ramda/src/pathOr';
import pluck from 'ramda/src/pluck';
import clone from 'ramda/src/clone';
export var processServiceFeatures = function processServiceFeatures(productId, product, pricingPlans, cart, featureOrderQuantities, routeParams, orders, changeOfServiceRequest, pricingPlanToExclude) {
  var shoppingCart = clone(cart);
  var existingMutableCart = clone(cart);
  var unmodifiedAddItems = changeOfServiceRequest.AddItems && changeOfServiceRequest.AddItems.length ? getUnmodifiedItems(productId, changeOfServiceRequest.AddItems, pricingPlanToExclude) : [];
  var unmodifiedRemoveItems = changeOfServiceRequest.RemoveItems && changeOfServiceRequest.RemoveItems.length ? getUnmodifiedItems(productId, changeOfServiceRequest.RemoveItems, pricingPlanToExclude) : [];
  shoppingCart.AddItems = !shoppingCart.AddItems ? [] : shoppingCart.AddItems;
  shoppingCart.AddItems = shoppingCart.AddItems.concat(unmodifiedAddItems);
  shoppingCart.RemoveItems = !shoppingCart.RemoveItems ? [] : shoppingCart.RemoveItems;
  shoppingCart.RemoveItems = shoppingCart.RemoveItems.concat(unmodifiedRemoveItems);
  var additionalCartItems = [];
  if (pricingPlans && pricingPlans.length) {
    pricingPlans.forEach(function (pricingPlan) {
      var existingQuantities = featureOrderQuantities.filter(function (feature) {
        return feature.productId === productId && feature.pricingPlanId === pricingPlan.Id;
      });
      var cartItem = {
        Details: {
          PricingPlan: pricingPlan,
          Product: product
        },
        PricingPlanId: pricingPlan.Id,
        ProductId: productId,
        Quantity: 0,
        ServiceFeatureProductAssociation: {
          ServiceId: routeParams.serviceTypeId,
          ServiceIdentifierValue: routeParams.serviceId,
          ServiceInstanceId: routeParams.serviceInstanceId
        },
        ShoppingCartItemBillerRuleDetails: pricingPlan.ShoppingCartItemBillerRuleDetails
      };
      var countDiff = 0;
      var isAdd = pricingPlan.cartQuantity > existingQuantities.length;
      var isModify = false;
      var isRemove = pricingPlan.cartQuantity < existingQuantities.length;
      if (isAdd || isRemove) {
        countDiff = Math.abs(pricingPlan.cartQuantity - existingQuantities.length);
      } else if (existingQuantities.length && pricingPlan.cartQuantity === existingQuantities.length) {
        if (pricingPlan.ShoppingCartItemBillerRuleDetails && existingQuantities[0].shoppingCartItemBillerRuleDetails && pricingPlan.ShoppingCartItemBillerRuleDetails.length !== existingQuantities[0].shoppingCartItemBillerRuleDetails.length || pricingPlan.ShoppingCartItemBillerRuleDetails && pricingPlan.ShoppingCartItemBillerRuleDetails.length && pricingPlan.ShoppingCartItemBillerRuleDetails[0].Amount !== existingQuantities[0].shoppingCartItemBillerRuleDetails[0].Amount) {
          isModify = true;
          countDiff = pricingPlan.cartQuantity;
        }
        ;
      }
      for (var quant = 0; quant < pricingPlan.cartQuantity; quant++) {
        cartItem.Quantity = 1;
        additionalCartItems.push(cartItem);
      }
      while (countDiff > 0) {
        if (isAdd || isModify) {
          shoppingCart.AddItems.push(cartItem);
        }
        if (isRemove || isModify) {
          buildRemoveItems(isRemove || isModify, pricingPlan, featureOrderQuantities, shoppingCart, cartItem, productId, orders, countDiff - 1);
        }
        countDiff--;
      }
    });
  }
  ;
  shoppingCart.Items = [].concat(additionalCartItems, _toConsumableArray(getUnModifiedCartItems(existingMutableCart, routeParams, featureOrderQuantities, productId)));
  return shoppingCart;
};

//build remove items
var buildRemoveItems = function buildRemoveItems(quantityChanged, pricingPlan, featureOrderQuantities, shoppingCart, cartItem, productId, orders, countDiff) {
  if (quantityChanged) {
    var subscriberProductQuantities = featureOrderQuantities.filter(function (quantity) {
      return quantity.productId === productId && quantity.pricingPlanId === pricingPlan.Id;
    });
    var subscriberProductsIds = subscriberProductQuantities && subscriberProductQuantities.length ? pluck('subscriberProductId', subscriberProductQuantities) : [];
    var foundOrderItem = getOrderItem(orders, productId, pricingPlan.Id, subscriberProductsIds[countDiff]);
    var removeItem = clone(cartItem);
    removeItem.Quantity = 1;
    removeItem.LockerItemId = subscriberProductsIds[countDiff];
    removeItem.ServiceFeatureProductAssociation = Object.assign({}, removeItem.ServiceFeatureProductAssociation, {
      OrderItemId: foundOrderItem ? foundOrderItem.Id : null
    });
    if (foundOrderItem) {
      shoppingCart.RemoveItems.push(removeItem);
    }
  }
};
export var getUnmodifiedItems = function getUnmodifiedItems(productId, items, pricingPlanToExclude) {
  var unmodifiedItems = [];
  if (!pricingPlanToExclude) {
    unmodifiedItems = unmodifiedItems.concat(items.filter(function (item) {
      return item.ProductId !== productId;
    }));
  } else {
    unmodifiedItems = unmodifiedItems.concat(items.filter(function (item) {
      return item.ProductId === productId && item.PricingPlanId !== pricingPlanToExclude;
    }).concat(items.filter(function (item) {
      return item.ProductId !== productId;
    })));
  }
  return unmodifiedItems;
};
export var getOrderItem = function getOrderItem(orders, productId, pricingPlanId, lockerItemId) {
  var foundOrderItem = null;
  if (orders) {
    orders.forEach(function (order) {
      order.OrderItems.forEach(function (orderItem) {
        if (orderItem.Product.Id === productId && orderItem.PricingPlan.Id === pricingPlanId && orderItem.LockerItemId === lockerItemId) {
          foundOrderItem = orderItem;
        }
      });
    });
  }
  return foundOrderItem;
};
export var getUnModifiedCartItems = function getUnModifiedCartItems(shoppingCart, routeParams, featureOrderQuantities, productId) {
  var unmodifiedItems = [];
  if (shoppingCart.Items && shoppingCart.Items.length) {
    shoppingCart.Items.forEach(function (item) {
      if (productId !== item.ProductId) {
        item.ServiceFeatureProductAssociation = {
          AssociatedServiceSubscriberProductId: routeParams.subscriberProductId,
          ServiceId: routeParams.serviceTypeId,
          ServiceIdentifierValue: routeParams.serviceId,
          ServiceInstanceId: routeParams.serviceInstanceId
        };
        unmodifiedItems.push(item);
      }
    });
  }
  return unmodifiedItems;
};
export var getExistingQuantities = function getExistingQuantities(pricingPlanId, productId, featureOrderQuantities) {
  var existingQuantities = featureOrderQuantities.filter(function (feature) {
    return feature.productId === productId && feature.pricingPlanId === pricingPlanId;
  });
  return pathOr(0, ['length'], existingQuantities);
};
export var splitIndividualProducts = function splitIndividualProducts(products) {
  var splitProducts = [];
  products.forEach(function (product) {
    for (var counter = 0; counter < product.quantity; counter++) {
      splitProducts.push(Object.assign({}, product, {
        quantity: 1,
        standalone: true
      }));
    }
  });
  return splitProducts;
};